import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "provinces",
    object: "province",
    header: [
      { text: "Nombre", value: "name" },
      { text: "Precio", value: "price" },
      { text: "Ciudades", value: "cities", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
